import { c as _c } from "react/compiler-runtime";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { LoginStatus } from "@website/store/store";
import { Button } from "@website/ui/button";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { useClientLoaded } from "@website/utils/client-loaded/useClientLoaded";
import { ProfileMenu } from "@website/widget/header/components/profile-menu";
import { useLoginModal } from "@website/widget/login";
import { useState } from "react";
import { useSnappPro } from "../hooks/use-snapp-pro";
export function HeaderLogin() {
  const $ = _c(17);
  const {
    onLoginModalOpen
  } = useLoginModal();
  const {
    hasSnappPro,
    snappProIcon
  } = useSnappPro();
  const {
    loginStatus
  } = useLoginStatus();
  const {
    clientLoaded
  } = useClientLoaded();
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isChannel(["telesale", "b2b"]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isB2BOrTelesale = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function toggleProfileMenu() {
      if (isB2BOrTelesale) {
        window.location.href = "/profile";
      } else {
        setIsProfileMenuVisible(_temp);
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleProfileMenu = t1;
  if (!clientLoaded || loginStatus === LoginStatus.Pending) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="lg:hidden"><Skeleton height={36} width={36} shape="circle" /></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <>{t2}<div className="hidden lg:flex"><Skeleton height={40} width={111} className="rounded-full" /></div></>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (loginStatus === LoginStatus.Success) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Button EndIcon={<MaterialIcon name="person_outline" variant="outlined" />} aria-label={"\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC"} className="!mx-0 lg:!hidden" color="neutral" equalDimension={true} href="/profile" role="link" size="medium" variant="round-outline" />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Button EndIcon={<MaterialIcon name="keyboard_arrow_down" />} StartIcon={<MaterialIcon name="person" />} className="max-lg:!hidden" color="secondary" onClick={toggleProfileMenu} role="button" size="medium" variant="round-outline">حساب کاربری</Button>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== hasSnappPro || $[7] !== snappProIcon) {
      t4 = Boolean(hasSnappPro) && <img className="absolute bottom-0 right-2" src={snappProIcon} alt="snapp-pro-icon" />;
      $[6] = hasSnappPro;
      $[7] = snappProIcon;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== isProfileMenuVisible) {
      t5 = !isB2BOrTelesale && <ProfileMenu isOpen={isProfileMenuVisible} close={toggleProfileMenu} />;
      $[9] = isProfileMenuVisible;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t4 || $[12] !== t5) {
      t6 = <div className="relative">{t2}{t3}{t4}{t5}</div>;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="person" />;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== onLoginModalOpen) {
    t3 = <><Button EndIcon={t2} aria-label={"\u0648\u0631\u0648\u062F | \u062B\u0628\u062A \u0646\u0627\u0645"} className="!mx-0 lg:!hidden" color="secondary" equalDimension={true} onClick={onLoginModalOpen} role="button" target="_blank" variant="round" /><Button aria-label={"\u0648\u0631\u0648\u062F \u0648 \u062B\u0628\u062A \u0646\u0627\u0645"} className="max-lg:!hidden" color="secondary" onClick={onLoginModalOpen} size="medium" target="_blank" variant="round">ورود | ثبت نام</Button></>;
    $[15] = onLoginModalOpen;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
function _temp(previousState) {
  return !previousState;
}